const DATE_KEY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const toDate = (value) => {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getUtcDateKey = (value) => {
  const date = toDate(value);
  if (!date) {
    return null;
  }

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getLocalDateKey = (value, timezone = 'UTC') => {
  const date = toDate(value);
  if (!date) {
    return null;
  }

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone || 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);

  const acc = { year: '1970', month: '01', day: '01' };
  parts.forEach((part) => {
    if (part.type === 'year') acc.year = part.value;
    if (part.type === 'month') acc.month = part.value;
    if (part.type === 'day') acc.day = part.value;
  });

  return `${acc.year}-${acc.month}-${acc.day}`;
};

export const getQuestScheduleDateKey = (questOrValue) => {
  if (
    questOrValue
    && typeof questOrValue === 'object'
    && !(questOrValue instanceof Date)
  ) {
    if (typeof questOrValue.scheduledLocalDate === 'string' && DATE_KEY_PATTERN.test(questOrValue.scheduledLocalDate)) {
      return questOrValue.scheduledLocalDate;
    }

    if (typeof questOrValue.date === 'string' && DATE_KEY_PATTERN.test(questOrValue.date)) {
      return questOrValue.date;
    }

    return getUtcDateKey(questOrValue.start || questOrValue.date || null);
  }

  return getUtcDateKey(questOrValue);
};

export const isQuestScheduledForDate = (quest, value, fallbackTimezone = 'UTC') => {
  if (!quest || !value) {
    return false;
  }

  const timezone = quest?.userTimezoneAtScheduling || fallbackTimezone;
  return getQuestScheduleDateKey(quest) === getLocalDateKey(value, timezone);
};
